import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import css from './VerifiedHandoffBadge.module.css';

/**
 * VerifiedHandoffBadge component
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className - Custom class that extends the default class for the root element
 * @returns {JSX.Element} Small badge showing "📸 Verified Handoff"
 */
const VerifiedHandoffBadge = props => {
  const { className } = props;
  
  const classes = classNames(css.root, className);
  
  return (
    <div className={classes}>
      <FormattedMessage id="VerifiedHandoffBadge.label" />
    </div>
  );
};

export default VerifiedHandoffBadge;